module.exports = __webpack_public_path__ + "img/icon-business-receive-05.svg";